export interface FAQItem {
  question: string;
  answer: string;
}

export const faqItems: FAQItem[] = [
  {
    question: "土豪漫画网是什么？",
    answer: "土豪漫画网是一个专业的韩漫在线阅读平台，提供海量韩国漫画资源，支持韩漫全集下拉式阅读体验。我们致力于为漫画爱好者提供高清、流畅的韩漫在线阅读服务，无需下载即可享受沉浸式阅读乐趣。",
  },
  {
    question: "网站上的漫画是否需要付费？",
    answer: "土豪漫画网提供韩漫在线免费阅读服务，所有漫画内容均可在网站上免费浏览。我们持续更新最新韩漫资源，让广大漫友能够第一时间看到喜欢的作品。",
  },
  {
    question: "什么是下拉式阅读？",
    answer: "下拉式阅读是韩国漫画（Webtoon）的主流阅读方式，专为手机和电脑屏幕优化设计。用户只需向下滚动页面，漫画内容就会连续呈现，无需翻页，阅读体验流畅自然，特别适合长条漫画的浏览。",
  },
  {
    question: "网站支持哪些设备阅读？",
    answer: "土豪漫画网采用响应式设计，完美适配电脑、平板和手机等多种设备。无论您使用什么设备访问，都能获得最佳的韩漫阅读体验。下拉式阅读方式让手机阅读更加方便。",
  },
  {
    question: "漫画更新频率如何？",
    answer: "我们保持与韩国漫画平台同步更新，热门的韩漫作品通常每周更新一话。您可以收藏喜欢的作品，方便随时追踪最新章节。连载中的作品会持续更新，已完结的作品则可以一次性畅读全集。",
  },
  {
    question: "如何查找特定类型的漫画？",
    answer: "您可以通过网站的漫画分类功能浏览不同类型的作品。我们设有热血、恋爱、玄幻、奇幻、悬疑、冒险等多个分类，点击分类标签即可查看该类别下的所有漫画，轻松找到感兴趣的韩国漫画大全。",
  },
];